'use client';

import { useEffect, useRef } from 'react';

/**
 * 当 condition 首次为 true 时执行 callback，组件生命周期内仅执行一次。
 */
export function useOnceWhen(condition: boolean, callback: () => void): void {
    const hasRun = useRef(false);
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        if (!condition || hasRun.current) {
            return;
        }
        hasRun.current = true;
        callbackRef.current();
    }, [condition]);
}
